import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Teleport as _Teleport } from "vue"
import _imports_0 from '@icon/addMark.svg'


const _hoisted_1 = { class: "footer" }
const _hoisted_2 = {
  id: "footer-start",
  class: "footer__content-start"
}
const _hoisted_3 = {
  id: "footer-center",
  class: "footer__content-start"
}
const _hoisted_4 = { class: "footer__content-end" }
const _hoisted_5 = { class: "footer-navigation_list" }
const _hoisted_6 = { class: "footer-navigation_link__shortcut" }
const _hoisted_7 = { class: "footer-navigation_link__help" }
const _hoisted_8 = { class: "footer-navigation_link__shortcut" }
const _hoisted_9 = { class: "footer-navigation_link__help" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "footer-navigation_link__shortcut" }
const _hoisted_12 = { class: "footer-navigation_link__help" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackByRoute = _resolveComponent("BackByRoute")!
  const _component_SubscriptionAdminBanner = _resolveComponent("SubscriptionAdminBanner")!
  const _component_AIResponseAgent = _resolveComponent("AIResponseAgent")!
  const _component_DisabledFeatureTooltip = _resolveComponent("DisabledFeatureTooltip")!
  const _component_ToDoWidget = _resolveComponent("ToDoWidget")!
  const _component_TooltipLearn = _resolveComponent("TooltipLearn")!
  const _component_icon = _resolveComponent("icon")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DropdownTooltip = _resolveComponent("DropdownTooltip")!
  const _component_MCreateEpic = _resolveComponent("MCreateEpic")!
  const _component_ModalInsufficientPermissions = _resolveComponent("ModalInsufficientPermissions")!
  const _component_ModalBusinessFeatures = _resolveComponent("ModalBusinessFeatures")!
  const _component_ModalEnterpriseFeatures = _resolveComponent("ModalEnterpriseFeatures")!
  const _component_ModalAiChat = _resolveComponent("ModalAiChat")!
  const _directive_close_popper = _resolveDirective("close-popper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.$route.meta?.hideBackButtonInFooter)
          ? (_openBlock(), _createBlock(_component_BackByRoute, {
              key: _ctx.$route.fullPath,
              class: "footer__back-button"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.showSubscriptionAdminBanner)
          ? (_openBlock(), _createBlock(_component_SubscriptionAdminBanner, {
              key: 0,
              trialEndDate: _ctx.trialEndDate
            }, null, 8, ["trialEndDate"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_4, [
        (_ctx.showAIButton)
          ? (_openBlock(), _createBlock(_component_DisabledFeatureTooltip, {
              key: 0,
              feature: "aiAssistant",
              modalId: "modal-enterprise-features",
              useAclField: "accessToAi",
              title: "Feature available to <br> Enterprise plan Users",
              class: "footer__ai-setup"
            }, {
              label: _withCtx(() => [
                (!_ctx.currentAiProfile.name && _ctx.isAdmin)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "footer__ai-setup-btn",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onShowAISetupModal && _ctx.onShowAISetupModal(...args)))
                    }, [
                      _createVNode(_component_AIResponseAgent, { name: "AI Set Up" })
                    ]))
                  : (_ctx.currentAiProfile.name)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        id: "aiProfile",
                        type: "button",
                        class: "footer__ai-setup-btn",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onShowAIModal && _ctx.onShowAIModal(...args)))
                      }, [
                        _createVNode(_component_AIResponseAgent, {
                          name: "AI",
                          img: _ctx.currentAiProfile.picture.pictureUrl
                        }, null, 8, ["img"])
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.$route.params?.accountId && _ctx.accountId && !_ctx.$route.meta?.hideToDoWidget)
          ? (_openBlock(), _createBlock(_component_ToDoWidget, { key: _ctx.keyByRoute }))
          : _createCommentVNode("", true),
        (_ctx.hasNavigationItems)
          ? (_openBlock(), _createBlock(_component_DropdownTooltip, {
              key: 2,
              iconSize: "md",
              class: _normalizeClass(["footer-navigation", [
          { 'navigation-rotate': _ctx.opened },
          { 'learn-tooltip pointer-none': _ctx.step === _ctx.selectedStep },
          { 'navigation-tramor': !_ctx.opened }
        ]]),
              distance: 8,
              shown: _ctx.showMenu || _ctx.selectedStep === _ctx.step,
              autoHide: _ctx.selectedStep !== _ctx.step,
              popperClass: `footer-navigation_poper  ${_ctx.selectedStep === _ctx.step ? 'pointer-none' : ''}`,
              placement: "top-end",
              onOnShowDropdown: _ctx.toggleNavigation,
              onOnHideDropdown: _ctx.toggleNavigation
            }, {
              after: _withCtx(() => [
                _createVNode(_component_TooltipLearn, {
                  step: _ctx.step,
                  show: _ctx.selectedStep === _ctx.step,
                  placement: "left",
                  skidding: -40,
                  distance: 150,
                  tooltipText: _ctx.$t(`learnTooltipText.${_ctx.step}`)
                }, null, 8, ["step", "show", "tooltipText"])
              ]),
              "tooltip-label": _withCtx(() => [
                _createVNode(_component_icon, {
                  data: _imports_0,
                  fill: false,
                  color: "var(--accent-03)",
                  width: "var(--icon-24)",
                  height: "var(--icon-24)"
                })
              ]),
              "tooltip-content": _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigationList, (nav, index) => {
                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(["footer-navigation_link", [{ 'navigation_link-remove': !nav.show }]])
                    }, [
                      (nav.show)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (nav.disabledByPlan)
                              ? (_openBlock(), _createBlock(_component_DisabledFeatureTooltip, {
                                  key: 0,
                                  feature: nav.feature,
                                  useAclField: "hasSubscriptionIgnoreDemo",
                                  class: "footer-navigation_link__item"
                                }, {
                                  label: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_6, [
                                      (nav.icon)
                                        ? (_openBlock(), _createBlock(_component_icon, {
                                            key: 0,
                                            data: nav.icon,
                                            fill: true,
                                            width: "var(--icon-24)",
                                            height: "var(--icon-24)"
                                          }, null, 8, ["data"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_BaseSubHeading, {
                                        size: "large",
                                        weight: "400"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(nav.label), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ])
                                  ]),
                                  after: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(nav.help), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["feature"]))
                              : (nav.to)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    class: "footer-navigation_link__item",
                                    to: nav.to
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_8, [
                                        (nav.icon)
                                          ? (_openBlock(), _createBlock(_component_icon, {
                                              key: 0,
                                              data: nav.icon,
                                              fill: true,
                                              width: "var(--icon-24)",
                                              height: "var(--icon-24)"
                                            }, null, 8, ["data"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_BaseSubHeading, {
                                          size: "large",
                                          weight: "400"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(nav.label), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _createElementVNode("span", _hoisted_9, _toDisplayString(nav.help), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    type: "button",
                                    class: "footer-navigation_link__item",
                                    onClick: _withModifiers(($event: any) => (_ctx.handleBtnNavigation(nav)), ["prevent"])
                                  }, [
                                    _createElementVNode("div", _hoisted_11, [
                                      (nav.icon)
                                        ? (_openBlock(), _createBlock(_component_icon, {
                                            key: 0,
                                            data: nav.icon,
                                            fill: true,
                                            width: "var(--icon-24)",
                                            height: "var(--icon-24)"
                                          }, null, 8, ["data"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_BaseSubHeading, {
                                        size: "large",
                                        weight: "400"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(nav.label), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _createElementVNode("span", _hoisted_12, _toDisplayString(nav.help), 1)
                                  ], 8, _hoisted_10))
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2)), [
                      [_directive_close_popper]
                    ])
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["class", "shown", "autoHide", "popperClass", "onOnShowDropdown", "onOnHideDropdown"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_MCreateEpic, {
        id: _ctx.project.name,
        onOnCreateEpic: _ctx.createEpic
      }, null, 8, ["id", "onOnCreateEpic"]),
      _createVNode(_component_ModalInsufficientPermissions),
      _createVNode(_component_ModalBusinessFeatures),
      _createVNode(_component_ModalEnterpriseFeatures),
      (_openBlock(), _createBlock(_component_ModalAiChat, { key: _ctx.accountId }))
    ]))
  ], 64))
}